import httpclient from 'libs/Axios';

export const fetchWhatsAppDemoStatus = async (mobile) => {
  if (!mobile || mobile === 'Not provided') return null;

  const response = await httpclient().get('/comm/whatsApp/demo/status', {
    params: { mobile },
  });

  return response?.data || null;
};

export const requestWhatsAppDemoApprovalQr = async ({ mobile }) => {
  const response = await httpclient().post('/comm/whatsApp/demo/qr', {
    MOBILE: mobile,
  });
  const payload = response?.data?.data || {};
  const qrValue = payload.qrImage || payload.qr_image || payload.QR_IMAGE
    || payload.qr || payload.QR || payload.qrCode || payload.QR_CODE || '';

  return {
    qrImage: qrValue && !String(qrValue).startsWith('data:') && !String(qrValue).startsWith('http')
      ? `data:image/png;base64,${qrValue}`
      : qrValue,
    waLink: payload.waLink || payload.wa_link || payload.WA_LINK || payload.link || '',
    token: payload.token || payload.TOKEN || '',
    expiresInSeconds: Number(payload.expiresInSeconds || payload.EXPIRES_IN_SECONDS || 0),
    raw: response?.data,
  };
};

export const sendParentEngageDemoMessage = async ({ mobile, feature, languageCode }) => {
  const response = await httpclient().post('/comm/whatsApp/demo/sendMessage', {
    MOBILE: mobile,
    FEATURE: feature,
    LANGUAGE_CODE: languageCode,
  });

  return response?.data;
};

export const sendWhatsAppDemo = async (messages) => {
  const response = await httpclient().post('/comm/internal/whatsApp/sendFreeForm', {
    MESSAGES: messages,
  });

  if (![200, 201, 202].includes(response?.data?.code)) {
    throw new Error(response?.data?.message || 'Unable to send the WhatsApp demo.');
  }
  return response.data;
};
